const formFieldTypes = {
  text: 'text',
  autocomplete: 'autocomplete',
  textarea: 'textarea',
  date: 'date',
  time: 'time',
  number: 'number'
}

export default formFieldTypes
